import React, { useEffect, useState } from 'react';
import { isNotNullOrUndefined, isNullOrUndefined } from '@utils/utils';
import { useTranslation } from 'react-i18next';
import { ImpersonationBanner } from '@components/layout/ImpersonationBanner.tsx';

interface ComponentProps {}

interface ApplicationInfo {
  commit_sha: string;
  commit_message: string;
}

export const TopInformation: React.FC<ComponentProps> = () => {
  const { t } = useTranslation('client');
  const [newVersion, setNewVersion] = useState<ApplicationInfo>();
  const [versionInfo, setVersionInfo] = useState<ApplicationInfo | undefined>(undefined);

  const setAndCheck = (data: ApplicationInfo) => {
    if (isNullOrUndefined(versionInfo)) {
      setVersionInfo(data);
    } else {
      if (data.commit_sha !== versionInfo.commit_sha) {
        console.log('New version available', data);
        setNewVersion(data);
      }
    }
  };

  const fetchAndCheck = (controller: AbortController) => {
    if (window.location.hostname === 'localhost') return;
    fetch('/version.json', { signal: controller.signal })
      .then(response => response.json())
      .then(data => setAndCheck(data))
      .catch(e => {
        if (!controller.signal.aborted) {
          console.log(e);
        }
      });
  };

  useEffect(() => {
    const controller = new AbortController();
    //const refreshInterval = window.location.origin.indexOf('localhost') != -1 ? null : window.location.origin.indexOf('pecosta.dev') != -1 ? 60000 : 5000;

    const refreshInterval = 5000;
    console.log(`TopInformation useEffect, refreshInterval: ${refreshInterval}`);

    fetchAndCheck(controller);

    if (refreshInterval == null)
      return () => {
        controller.abort();
      };

    const interval = setInterval(() => fetchAndCheck(controller), refreshInterval);

    return () => {
      controller.abort();
      if (interval) clearInterval(interval);
    };
  }, [versionInfo]);

  return (
    <>
      <ImpersonationBanner />
      {isNotNullOrUndefined(newVersion) && (
        <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-amber-400 to-orange-400 border-b border-amber-500 shadow-lg z-50">
          <div className="max-w-7xl mx-auto px-4 py-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="flex-shrink-0">
                  <svg className="h-6 w-6 text-amber-800" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div className="text-sm font-medium text-amber-800">
                  <span className="font-semibold">{t('shared.topInfo.newVersion')}</span>
                  <div className="text-xs text-amber-700 mt-1">{newVersion?.commit_message}</div>
                </div>
              </div>
              <button
                onClick={() => {
                  location.reload();
                }}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-amber-800 bg-amber-100 hover:bg-amber-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 transition-colors duration-200"
              >
                <svg className="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  />
                </svg>
                {t('shared.topInfo.refresh')}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
